import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert,
  Label,
  Input,
  FormGroup
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { multiEmail } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import axiosInstance from '@src/axios-instance';

const fieldValidator = {
  requestor_role_id: [],
  requestor_first_name: [],
  requestor_last_name: [],
  requestors_email: [multiEmail],
  requestors_phone: [],
  requestors_company_name: [],
  borrowers_email: [multiEmail],
  board_member: [],
  is_cognito: []
};

class ContactInformationModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value: props.entity[key] !== null ? props.entity[key] : '',
        visited: false,
        error: false
      };
    });

    fields['is_cognito'] = {
      value: 1,
      visited: false,
      error: false
    };

    this.state = {
      ...fields,
      roles: [],
      loaded: false
    };
    this.getRoles();
  }

  getRoles = () => {
    axiosInstance()
      .get(`/evidence-of-insurances/requestor-roles.json`)
      .then(response => {
        this.setState({
          roles: response.data
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event === null
          ? ''
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      this.props.onSubmit(postData, null);
    }
    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {'Contact Information'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              {this.props.errorUnit && (
                <Alert color={'danger'}>{this.props.errorUnit}</Alert>
              )}
              <FormGroup>
                <Label for="requestor-role">Requestor Role</Label>
                <Input
                  type={'select'}
                  name="type"
                  id="requestor-role"
                  value={this.state.requestor_role_id.value}
                  onChange={event =>
                    this.updateForm(event, 'requestor_role_id')
                  }
                >
                  {this.state.roles.map(item => {
                    return <option value={item.id}>{item.name}</option>;
                  })}
                </Input>
              </FormGroup>

              <Row>
                <Col xs={6}>
                  <LabelInput
                    name={'Requestor First Name'}
                    type={'text'}
                    {...this.state.requestor_first_name}
                    onChange={event =>
                      this.updateForm(event, 'requestor_first_name')
                    }
                  />
                </Col>
                <Col xs={6}>
                  <LabelInput
                    name={'Requestor Last Name'}
                    type={'text'}
                    {...this.state.requestor_last_name}
                    onChange={event =>
                      this.updateForm(event, 'requestor_last_name')
                    }
                  />
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'Requestor Email'}
                    type={'text'}
                    {...this.state.requestors_email}
                    onChange={event =>
                      this.updateForm(event, 'requestors_email')
                    }
                  />
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'Requestor Phone'}
                    type={'text'}
                    {...this.state.requestors_phone}
                    onChange={event =>
                      this.updateForm(event, 'requestors_phone')
                    }
                  />
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'Requestor Company'}
                    type={'text'}
                    {...this.state.requestors_company_name}
                    onChange={event =>
                      this.updateForm(event, 'requestors_company_name')
                    }
                  />
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'Borrower Email'}
                    type={'text'}
                    {...this.state.borrowers_email}
                    onChange={event =>
                      this.updateForm(event, 'borrowers_email')
                    }
                  />
                </Col>
                <Col xs={12}>
                  <FormGroup check className={'pb-1 pt-2'}>
                    <Label check>
                      <Input
                        style={{ top: '5px' }}
                        type="checkbox"
                        checked={this.state.board_member.value === 1}
                        onChange={event =>
                          this.updateForm(
                            event.currentTarget.checked ? 1 : 0,
                            'board_member'
                          )
                        }
                      />{' '}
                      Board Member
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default ContactInformationModal;
